import { render, staticRenderFns } from "./RecruiterWrapper.vue?vue&type=template&id=35fcb086&scoped=true"
import script from "./RecruiterWrapper.vue?vue&type=script&lang=ts"
export * from "./RecruiterWrapper.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterWrapper.vue?vue&type=style&index=0&id=35fcb086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fcb086",
  null
  
)

export default component.exports